// extracted by mini-css-extract-plugin
module.exports = {"frozen_ratio":"frozen_ratio___3CTgu","holder":"holder___3YVhN","main_content":"main_content___1k0sE"};